import { get, del } from '../..';
import { buildUrl } from '../../../utils';

export const getSystemAdminToken = () =>
  get(buildUrl('/v1/security/system-admin/token'));

export const fetchSystemAdminToken = () =>
  get(buildUrl('/v1/security/system-admin/user-token'));

export const deleteSystemAdminToken = (token: string) =>
  del(buildUrl(`/v1/security/system-admin/token/${token}`));
